module.exports = __webpack_public_path__ + "img/brand-3.290400b4.jpg";